import { MDBTable, MDBTableBody } from 'mdbreact'
import React from 'react'
import HeaderTabla from '../../HeaderTabla'
import { ChevronRight, User } from 'react-iconly'

const Perfil = () => {
    return (
        <div className="container perfil">
            <div className="row mx-1">
                <div className="col-md-4 mb-4">
                    <div className="card  rounded-0 testimonial-card mb-3">
                        <div className="card-up indigo lighten-1" />
                        <div className="avatar mx-auto white">
                            <img
                                src="https://mdbootstrap.com/img/Photos/Avatars/img%20%2810%29.webp"
                                className="rounded-circle"
                                alt="woman avatar"
                                width={100}
                            />
                        </div>
                        <div className="card-body pt-2 pb-2">
                            <h5 className="card-title mb-0 font-weight-bold">Anna Doe</h5>
                            <span>Estudiante</span>
                        </div>
                    </div>
                    <div className="card rounded-0 mb-1">
                        <div className='row m-0'>
                            <div className='col-md text-left py-2'>
                                <User set="bold" className="mr-2" />
                                <span>Perfil</span>
                            </div>
                            <div className='col-md-2 py-2'>
                                <ChevronRight set="light" />
                            </div>
                        </div>
                    </div>
                    <div className="card rounded-0 mb-1">
                        <div className='row m-0'>
                            <div className='col-md text-left py-2'>
                                <User set="bold" className="mr-2" />
                                <span>Pedidos</span>
                            </div>
                            <div className='col-md-2 py-2'>
                                <ChevronRight set="light" />
                            </div>
                        </div>
                    </div>
                    <div className="card rounded-0 mb-1">
                        <div className='row m-0'>
                            <div className='col-md text-left py-2'>
                                <User set="bold" className="mr-2" />
                                <span>Cerrar Sesión</span>
                            </div>
                            <div className='col-md-2 py-2'>
                                <ChevronRight set="light" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-8 mb-4 text-left ">
                    <h4 className='font-weight-bold'>Perfil</h4>
                    <p class="font-weight-bolder">Actualiza y revisa toda la información de tu perfil.</p>
                    <div className="card rounded-0 px-3 pt-2">
                        <h5 className='font-weight-bold'>Pedidos</h5>
                        <hr className='m-0' />
                        <MDBTable hover responsive  >
                            <HeaderTabla array={['ID', 'Fecha', 'estado', 'Cliente', 'Total', 'Imp', 'Pedido', '']} />
                            <MDBTableBody >
                            </MDBTableBody>
                        </MDBTable>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Perfil